import React from "react";
import styled, { css } from "styled-components";
import { cssIf } from "../../utils/styledMixins";

const _ValidationMessage = ({errorMessage, className, hideErrors}) => {
  const showErrorMessage = !!errorMessage;
  if (!showErrorMessage) {
    return null;
  }

  return (
    <span className={`${className} validation-message`} data-validation-scroll-target="">
      { !hideErrors && errorMessage }
    </span>
  );
};

export const ValidationMessage = styled(_ValidationMessage)(({ theme }) => css`
  position: absolute;
  padding: 5px 12px;
  bottom: -21px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  color: #fff;
  border-radius: 15px;
  font-size: 13px;
  background-color: ${theme.palette.input.error};
  
  ${cssIf(({hideErrors}) => !!hideErrors)`
    display: none;
  `}
`);